import React, { useState, useEffect } from "react";
import "./BestOf.css"; // Don't Remove
import ListItems from "../components/BestOf/ListItems";
import FilterDay from "../components/BestOf/FilterDay";
import Layout from "../components/BestOf/Layout";
import Header from "../components/BestOf/Header";
import { weekDay } from "../utils/DayEnToFr";
import getBestOfPostsAPI, { getPostAPI } from "../requests/getBestOfPostsAPI";
import Loader from "react-loader-spinner";
import { useBestOf } from '../context/BestOf';
import { useMenuBestOf } from "../context/MenuBestOf";
import { makeStyles, Theme, useTheme } from "@material-ui/core";

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    '& > *': {
      margin: theme.spacing(0.5),
    },
    marginBottom: 10,
    marginTop: 10
  },
  wrapperBestOf: {
    display: "grid",
    gridTemplateColumns: "repeat(8, 1fr)",
    gridGap: "10px",
    gridAutoRows: "minmax(10vh, auto)"
  },
  header: {
    gridColumn: "1 / 9",
    backgroundColor: theme.palette.background.paper,
    gridRow: "1",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center"
  },
  researchAera: {
    gridColumn: "7 / 9",
    backgroundColor: theme.palette.background.paper,
    gridRow: "2 / 10"
  },
  filtersContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    flexWrap: "wrap"
  },
  four: { 
    gridColumn: "1 / 7", 
    backgroundColor: theme.palette.background.paper, 
    gridRow: "2/10"
  },
  layoutLoader: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginTop: "50px"
  }
}));

const BestOf = () => {
  const {state, dispatch} = useBestOf();
  const { state: stateMenu} = useMenuBestOf();
  const [searchTerm, setSearchTerm] = useState("");
  const classes = useStyles();
  const theme = useTheme();

  const editSearchTerm = (e: any) => {
    setSearchTerm(e.target.value);
  };

  const dynamicSearch = () => {
    return state.searchResult.filter((item) =>
      item.title.toLowerCase().includes(searchTerm.toLowerCase())
    );
  };

  const itemIsIn = (array: any, item: any): boolean => {
    for (let i = 0; i < array.length; i++) {
      if (array[i].slug === item.slug) {
        return (true);
      }
    }
    return (false);
  }

  const dynamicShowPost = (arrayOfResearch: any[]) => {
    let bool = false;
    
    // Filtre dans les articles porposés les filtres déjà sélectionnés
    return arrayOfResearch.filter((item: any) => {
      for (let i = 0; i < weekDay.length; i++) {
        bool = itemIsIn(state.postByDay[weekDay[i]], item);
        if (bool) {
          return (!bool);
        }
      }
      return (!bool)
    })
  }
  // Same ?
  // const dynamicShowPost = (arrayOfResearch: any) => (
  //   arrayOfResearch.filter((item: any) =>
  //     !weekDay.find(day => itemIsIn(state.postByDay[day], item))
  //   )
  // );

  useEffect(() => {
    if (!stateMenu.pickedBestOf) {
      if (!stateMenu.daysBestOf)
        dispatch({type: "GENERATE_WEEK_DAY", payload: {}})
      else
        dispatch({type: "SET_WEEK_DAY", payload: {daysBestOf: stateMenu.daysBestOf}})
    } else {
      dispatch({type: "SET_WEEK_DAY", payload: {daysBestOf: stateMenu.pickedBestOf.days}})
      getBestOfPostsAPI(stateMenu.pickedBestOf.bestOfPosts, dispatch);
      getPostAPI(stateMenu.pickedBestOf.postCover, dispatch);
    }
    return () => {};
  }, []);

  return (
    <div className="App">
      <div className={classes.wrapperBestOf}>
        <div className={classes.header}>
          <Header />
        </div>
        <div className={classes.researchAera}>
          <div className={classes.root}>
            {state.allDayBestOf.map((day) => (
              <FilterDay
                key={day}
                day={day}
              ></FilterDay>
            ))}
          </div>
          <div className="form__group">
            <input
              type="text"
              className="form__input"
              value={searchTerm}
              onChange={editSearchTerm}
              placeholder="Search by posts"
            />
          </div>
          {(state.isLoadingResearch === 2) 
            ?
            <div className={classes.layoutLoader}>
             <Loader type="Oval" height={40} width={40} color={theme.palette.primary.dark}/>
            </div>
            : 
          <ListItems items={dynamicShowPost(dynamicSearch())}>
          </ListItems>}
        </div>
        <div className={classes.four}>
          {
            (state.isLoading === 1) 
            ?
            <div className={classes.layoutLoader}>
              <Loader type="Oval" height={40} width={40} color={theme.palette.primary.dark}/>
            </div>
            :
            <Layout />
          }
        </div>
      </div>
    </div>
  );
};

export default BestOf;
